import { computed, observable, runInAction } from 'mobx';
import ErrorUtil from '../error/ErrorUtil';
import API from '../util/ApiUtil';

export interface PriceRate {
  monthly: string;
  daily: string;
}

export interface InsuranceResult {
  hull: PriceRate;
  traffic: PriceRate;
}

class InsuranceStore {
  @observable accessor state: string = '';
  @observable accessor result: InsuranceResult;

  public fetchInsuranceInfos = async (idCode: string, regCode: string) => {
    try {
      runInAction(() => {
        this.state = 'FETCHING';
      });
      const response = await API.get('/vehicle-insurance/ergo', {
        params: { idCode, regCode },
      });
      runInAction(() => {
        this.result = response.data;
      });
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e as Error);
      runInAction(() => {
        this.result = null;
      });
    } finally {
      runInAction(() => {
        this.state = 'FETCHED';
      });
    }
  };

  @computed
  get hasResults() {
    return !!this.result && !!this.result.traffic && !!this.result.hull && !!this.result.traffic.daily && !!this.result.traffic.monthly;
  }
}

export default InsuranceStore;
